/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
$(window).scroll(function (){
	$('.fade-left').each(function(){
	var POS = $(this).offset().top;
	var scroll = $(window).scrollTop();
	var windowHeight = $(window).height();
	if (scroll > POS - windowHeight){
		$(this).css({
		    'opacity':'1',
			'transition-delay':'200ms',
			'transition-duration':'1500ms',
			'transition-timing-function':'cubic-bezier(0,1,1,1.1)',
		    'transform':'translateX(0)',
		    '-webkit-transform':'translateX(0)',
		    '-moz-transform':'translateX(0)',
		    '-ms-transform':'translateX(0)'
		});
	} else {
		$(this).css({
		    'opacity':'0',
		});
	}
	});
	$('.fade-right').each(function(){
	var POS = $(this).offset().top;
	var scroll = $(window).scrollTop();
	var windowHeight = $(window).height();
	if (scroll > POS - windowHeight){
		$(this).css({
		    'opacity':'1',
			'transition-delay':'200ms',
			'transition-duration':'1500ms',
			'transition-timing-function':'ease-in-out',
		    'transform':'translateX(0)',
		    '-webkit-transform':'translateX(0)',
		    '-moz-transform':'translateX(0)',
		    '-ms-transform':'translateX(0)'
		});
	} else {
		$(this).css({
		    'opacity':'0',
		});
	}
	});

});